import { fetchData } from "./fetchData";

export const fetchAllPages = async <T>(
  endpoint: string,
  queryString: string,
  pageSize: number,
  getToken: () => Promise<string | undefined>
): Promise<T[]> => {
  const allItems: T[] = [];
  let currentPage = 0;
  let hasMore = true;

  while (hasMore) {
    const response = await fetchData(`${endpoint}`, getToken, queryString, {
      page: currentPage,
      pageSize
    });

    const pageItems = response.items as T[];
    allItems.push(...pageItems);

    hasMore =
      pageItems.length === pageSize &&
      response.totalItems > (currentPage + 1) * pageSize;

    currentPage++;
  }

  return allItems;
};
